function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { ErrorReason, ErrorSeverity } from '../../../error';
import { sdkLogger } from '../../../logger';
import { Observable } from '../../../utils/observables/observable';
import { checkIsManifestLinearType, checkIsManifestVodType, checkIsSessionItemSleAutoplayType } from '../../../utils/playback-type';
import { DvrWindowDuration, PlayerDrmError } from '../../player/playout-data';
import { VideoFormat, VideoColourSpace } from '../../player/video-format';
import { InternalSessionState } from '../internal-session-state';
import { COLOUR_SPACE_ACTIVATION_ERROR_PREFIX } from '../session-controller-internal';
import { SessionRestartStatus, SessionRestartType } from './session-restart-controller.enums';
import { AudioRole } from '../../player/role';
export { SessionRestartStatus, SessionRestartType } from './session-restart-controller.enums';
// Amount of time that should pass before another retry can occur
// 30 minutes
var DEFAULT_COOLDOWN_PERIOD_SECS = 1800;
var MAX_720P_BITRATE_CAP = 5000000;
var HDCP_ERROR_CODE = 'HDCP';
var ROBUSTNESS_FAILURE_STEPDOWN = [
    VideoFormat.UHD,
    VideoFormat.HD,
    VideoFormat.SD
];
var LOWEST_VIDEO_FORMAT = ROBUSTNESS_FAILURE_STEPDOWN[ROBUSTNESS_FAILURE_STEPDOWN.length - 1];
export var SessionRestartController = /*#__PURE__*/ function() {
    "use strict";
    function SessionRestartController(controllerFactory, sessionEventProxy, sessionItem, hdcManager) {
        var _this = this;
        _class_call_check(this, SessionRestartController);
        var _this1 = this;
        _define_property(this, "controllerFactory", void 0);
        _define_property(this, "sessionEventProxy", void 0);
        _define_property(this, "currentSession", void 0);
        _define_property(this, "sessionFatalError", void 0);
        _define_property(this, "restartStatus", void 0);
        _define_property(this, "isSeeking", void 0);
        _define_property(this, "lastRetryDateTimestamp", void 0);
        _define_property(this, "hasReceivedSleBingeEvent", void 0);
        _define_property(this, "hasSessionFinishedLoading", void 0);
        _define_property(this, "hasInitialLoad", void 0);
        _define_property(this, "availableAudioTracks", void 0);
        _define_property(this, "newPreferredAudioTrack", void 0);
        _define_property(this, "newPreferredSubtitlesTrack", void 0);
        _define_property(this, "newPreferredBitrateCap", void 0);
        _define_property(this, "newMaxVideoFormat", void 0);
        _define_property(this, "playbackTimeline", void 0);
        _define_property(this, "audioState", void 0);
        _define_property(this, "currentCdnName", void 0);
        _define_property(this, "isVodManifest", void 0);
        _define_property(this, "isLinearManifest", void 0);
        _define_property(this, "isUsingExtendedDvrWindow", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "internalRetryConfig", void 0);
        _define_property(this, "restartSessionInitiatedObservable", void 0);
        _define_property(this, "robustnessFailoverObservable", void 0);
        _define_property(this, "isStoppingSessionForRestart", void 0);
        _define_property(this, "isRetryEnabledForSessionItem", void 0);
        _define_property(this, "listenToSessionEvents", void 0);
        _define_property(this, "errorTransformer", void 0);
        _define_property(this, "stateChangeTransformer", void 0);
        _define_property(this, "handleRestart", void 0);
        _define_property(this, "handlePlaybackTimeline", void 0);
        _define_property(this, "handlePlayoutDataReceived", void 0);
        this.controllerFactory = controllerFactory;
        this.sessionEventProxy = sessionEventProxy;
        this.sessionFatalError = null;
        this.restartStatus = SessionRestartStatus.IDLE;
        this.isSeeking = false;
        this.lastRetryDateTimestamp = 0;
        this.hasReceivedSleBingeEvent = false;
        this.hasSessionFinishedLoading = false;
        this.hasInitialLoad = false;
        this.playbackTimeline = null;
        this.audioState = {};
        this.isUsingExtendedDvrWindow = false;
        this.logger = sdkLogger.withContext('SessionRestartController');
        this.restartSessionInitiatedObservable = new Observable();
        this.robustnessFailoverObservable = new Observable();
        this.isStoppingSessionForRestart = false;
        this.isRetryEnabledForSessionItem = true;
        this.listenToSessionEvents = function(sessionController) {
            var // These are the states where we can consider that the session has finished Loading successfully
            _sessionController_waitForOneOfStates;
            sessionController.onPlaybackTimelineUpdated(_this.handlePlaybackTimeline.bind(_this));
            sessionController.onPlayoutDataReceived(_this.handlePlayoutDataReceived.bind(_this));
            sessionController.onEndOfEventMarkerReceived(function() {
                return _this.hasReceivedSleBingeEvent = true;
            });
            sessionController.onVolumeChanged(function(volume) {
                return _this.audioState.volume = volume;
            });
            sessionController.onMuteChanged(function(isMuted) {
                return _this.audioState.muted = isMuted;
            });
            sessionController.onAvailableAudioTracksChanged(function(tracks) {
                return _this.availableAudioTracks = tracks;
            });
            sessionController.onAudioTrackChanged(function(trackId) {
                if (_this.hasSessionFinishedLoading) {
                    var _this_availableAudioTracks;
                    var audioTrack = (_this_availableAudioTracks = _this.availableAudioTracks) === null || _this_availableAudioTracks === void 0 ? void 0 : _this_availableAudioTracks.find(function(param) {
                        var id = param.id;
                        return id === trackId;
                    });
                    _this.newPreferredAudioTrack = audioTrack;
                }
            });
            sessionController.onSubtitlesTrackChanged(function(track) {
                if (_this.hasSessionFinishedLoading && !(track === null || track === void 0 ? void 0 : track.forced)) {
                    _this.newPreferredSubtitlesTrack = track;
                }
            });
            sessionController.onBitrateCapChanged(function(bitrateCap) {
                if (_this.hasSessionFinishedLoading) {
                    _this.newPreferredBitrateCap = bitrateCap.value;
                }
            });
            sessionController.onQualityFailover(function(videoFormat) {
                if (!_this.hasSessionFinishedLoading) {
                    _this.newMaxVideoFormat = videoFormat;
                }
            });
            sessionController.onSeekStarted(function() {
                _this.isSeeking = true;
            });
            sessionController.onSeekEnded(function() {
                _this.isSeeking = false;
            });
            (_sessionController_waitForOneOfStates = sessionController.waitForOneOfStates([
                InternalSessionState.Playing,
                InternalSessionState.Paused,
                InternalSessionState.Seeking
            ])) === null || _sessionController_waitForOneOfStates === void 0 ? void 0 : _sessionController_waitForOneOfStates.then(function() {
                _this.hasSessionFinishedLoading = true;
                _this.hasInitialLoad = true;
            }).catch(function(e) {
                sdkLogger.warn('Initial session never finished loading - this can be valid for VSF scenarios: ', e);
            });
        };
        this.errorTransformer = function(error) {
            var adaptedError = error;
            if ((adaptedError === null || adaptedError === void 0 ? void 0 : adaptedError.severity) === ErrorSeverity.Fatal && _this.isErrorRecoverable(adaptedError)) {
                if (_this.canRetryWithError(error)) {
                    Object.assign(adaptedError, {
                        originalSeverity: adaptedError.severity,
                        severity: ErrorSeverity.Warning
                    });
                }
                _this.sessionFatalError = adaptedError;
            }
            return adaptedError;
        };
        this.stateChangeTransformer = function(newState) {
            var error = _this.sessionFatalError;
            // Note: VSFs need to simulate loading state, VPFs need to simulate rebuffering state
            if (_this.restartStatus === SessionRestartStatus.RESTARTING || _this.restartStatus === SessionRestartStatus.VPF_RETRYING) {
                // Note: While in a retrying state of any kind, we need to simulate additional events and potentially end the retrying state
                switch(newState){
                    case InternalSessionState.Loading:
                        _this.sessionEventProxy.notifyRebufferStart();
                        return _this.isVsfRetry(error) ? newState : InternalSessionState.Rebuffering;
                    case InternalSessionState.PlayerLoading:
                        if (_this.isRobustnessFailoverRetry() && !_this.isSessionLowestVideoFormat()) {
                            // Break out of retry state for robustness failures that have downgrades remaining
                            _this.restartStatus = SessionRestartStatus.IDLE;
                        }
                        return _this.isVsfRetry(error) ? newState : InternalSessionState.Rebuffering;
                    case InternalSessionState.Playing:
                    case InternalSessionState.Paused:
                    case InternalSessionState.Seeking:
                        if (_this.restartStatus === SessionRestartStatus.VPF_RETRYING && error) {
                            _this.sessionEventProxy.notifySessionRetryEnded(error);
                        } else if (_this.restartStatus === SessionRestartStatus.RESTARTING) {
                            _this.sessionEventProxy.notifySessionRestartEnded();
                        }
                        _this.sessionEventProxy.notifyRebufferEnd();
                        _this.sessionFatalError = null;
                        _this.restartStatus = SessionRestartStatus.IDLE;
                        return newState;
                    default:
                        return newState;
                }
            }
            // Note: At this point we are in an IDLE retry state and have full control over responding to errors
            if (_this.isColourSpaceRetry(error)) {
                return InternalSessionState.Loading;
            } else if (_this.canRetryWithError() && _this.isStopping(newState)) {
                _this.restartStatus = SessionRestartStatus.IDLE;
                if (newState === InternalSessionState.Stopped) {
                    _this.restart(SessionRestartType.VPF_RETRY);
                }
                return error && _this.isVsfRetry(error) ? InternalSessionState.Loading : InternalSessionState.Rebuffering;
            } else if (_this.isStoppingSessionForRestart) {
                return InternalSessionState.Rebuffering;
            }
            return newState;
        };
        this.handleRestart = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(restartType) {
                var restartOptions;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.logger.info("Restarting session (Type: ".concat(SessionRestartType[restartType], ")"));
                            restartOptions = _this1.createRestartOptions(restartType);
                            return [
                                4,
                                _this1.prepareForRestart(restartType)
                            ];
                        case 1:
                            _state.sent();
                            _this1.restartSessionInitiatedObservable.notifyObservers(restartOptions);
                            _this1.currentSession = _this1.createSessionController();
                            if (restartType === SessionRestartType.VPF_RETRY) {
                                // Only VPF retry should have a cooldown
                                _this1.lastRetryDateTimestamp = Date.now();
                            }
                            return [
                                4,
                                _this1.currentSession.start()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(restartType) {
                return _ref.apply(this, arguments);
            };
        }();
        this.handlePlaybackTimeline = function(playbackTimeline) {
            if (_this.hasSessionFinishedLoading && !_this.isSeeking) {
                _this.playbackTimeline = playbackTimeline;
            }
        };
        this.handlePlayoutDataReceived = function(playoutData) {
            _this.isVodManifest = checkIsManifestVodType(playoutData.type);
            _this.isLinearManifest = checkIsManifestLinearType(playoutData.type);
            // The CDN that is used is always the first one in the array
            var _playoutData_cdns_ = playoutData.cdns[0], name = _playoutData_cdns_.name, streamInfo = _playoutData_cdns_.streamInfo;
            _this.currentCdnName = name;
            if (_this.isLinearManifest && streamInfo && 'windowDuration' in streamInfo) {
                _this.isUsingExtendedDvrWindow = streamInfo.windowDuration !== DvrWindowDuration.Restricted;
            }
        };
        this.internalRetryConfig = this.buildInternalConfig(sessionItem);
        this.sessionEventProxy.setEventTransformers({
            onStateChanged: [
                this.stateChangeTransformer.bind(this)
            ],
            onError: [
                this.errorTransformer.bind(this)
            ]
        });
        this.setIsRetryEnabledForSessionItem(sessionItem);
    }
    _create_class(SessionRestartController, [
        {
            key: "isRestarting",
            value: function isRestarting() {
                return this.restartStatus !== SessionRestartStatus.IDLE;
            }
        },
        {
            key: "onRestartSessionInitiated",
            value: function onRestartSessionInitiated(callback) {
                this.restartSessionInitiatedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRobustnessFailover",
            value: function onRobustnessFailover(callback) {
                this.robustnessFailoverObservable.registerObserver(callback, this);
            }
        },
        {
            key: "initialise",
            value: function initialise() {
                this.currentSession = this.createSessionController();
                this.currentSession.onCdnSwitch(this.handleCdnSwitch.bind(this));
            }
        },
        {
            key: "startSession",
            value: function startSession() {
                var _this_currentSession;
                (_this_currentSession = this.currentSession) === null || _this_currentSession === void 0 ? void 0 : _this_currentSession.start();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.restartSessionInitiatedObservable.unregisterObservers(this);
                this.robustnessFailoverObservable.unregisterObservers(this);
                this.currentSession = undefined;
            }
        },
        {
            key: "handleCdnSwitch",
            value: function handleCdnSwitch(event) {
                this.currentCdnName = event.toCdn.name;
            }
        },
        {
            key: "buildInternalConfig",
            value: function buildInternalConfig(sessionItem) {
                var _CoreVideoInternal_getPropositionExtensions, _CoreVideoInternal_display;
                var sessionRetryConfig = sessionItem.sessionRetryConfig, display = sessionItem.display, enableQualityFailover = sessionItem.enableQualityFailover;
                var _sessionRetryConfig_enabled, _sessionRetryConfig_hdcpFailoverEnabled, _CoreVideoInternal_getPropositionExtensions_robustnessFailover;
                var internalRetryConfig = {
                    vpfRetryEnabled: (_sessionRetryConfig_enabled = sessionRetryConfig === null || sessionRetryConfig === void 0 ? void 0 : sessionRetryConfig.enabled) !== null && _sessionRetryConfig_enabled !== void 0 ? _sessionRetryConfig_enabled : false,
                    qualityFailoverEnabled: enableQualityFailover !== null && enableQualityFailover !== void 0 ? enableQualityFailover : false,
                    colourSpaceRetryEnabled: false,
                    cooldownPeriodSecs: sessionRetryConfig === null || sessionRetryConfig === void 0 ? void 0 : sessionRetryConfig.cooldownPeriodSecs,
                    hdcpFailoverRetryEnabled: (_sessionRetryConfig_hdcpFailoverEnabled = sessionRetryConfig === null || sessionRetryConfig === void 0 ? void 0 : sessionRetryConfig.hdcpFailoverEnabled) !== null && _sessionRetryConfig_hdcpFailoverEnabled !== void 0 ? _sessionRetryConfig_hdcpFailoverEnabled : false,
                    robustnessFailoverEnabled: (_CoreVideoInternal_getPropositionExtensions_robustnessFailover = (_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions.robustnessFailover) !== null && _CoreVideoInternal_getPropositionExtensions_robustnessFailover !== void 0 ? _CoreVideoInternal_getPropositionExtensions_robustnessFailover : false
                };
                if ((sessionRetryConfig === null || sessionRetryConfig === void 0 ? void 0 : sessionRetryConfig.enabled) && typeof (sessionRetryConfig === null || sessionRetryConfig === void 0 ? void 0 : sessionRetryConfig.cooldownPeriodSecs) !== 'number') {
                    internalRetryConfig.cooldownPeriodSecs = DEFAULT_COOLDOWN_PERIOD_SECS;
                }
                if (((_CoreVideoInternal_display = CoreVideoInternal.display) === null || _CoreVideoInternal_display === void 0 ? void 0 : _CoreVideoInternal_display.activateColourSpace) && (display === null || display === void 0 ? void 0 : display.playerViewAlwaysPresentedFullScreen)) {
                    internalRetryConfig.colourSpaceRetryEnabled = true;
                }
                return internalRetryConfig;
            }
        },
        {
            key: "createSessionController",
            value: function createSessionController() {
                var sessionController = this.controllerFactory();
                this.listenToSessionEvents(sessionController);
                return sessionController;
            }
        },
        {
            key: "isColourSpaceRetry",
            value: function isColourSpaceRetry(error) {
                return error === null || error === void 0 ? void 0 : error.code.startsWith(COLOUR_SPACE_ACTIVATION_ERROR_PREFIX);
            }
        },
        {
            key: "isHdcpRetry",
            value: function isHdcpRetry(error) {
                return error.code.toUpperCase().includes(HDCP_ERROR_CODE);
            }
        },
        {
            key: "isQualityFailoverRetry",
            value: function isQualityFailoverRetry(error) {
                if (!error) return false;
                return error.code.indexOf('SDK.QUALITY.FAILOVER') >= 0;
            }
        },
        {
            key: "isRobustnessFailoverRetry",
            value: function isRobustnessFailoverRetry(error) {
                if (!error) return false;
                return error.code.indexOf(PlayerDrmError.ROBUSTNESS_FAILURE) >= 0;
            }
        },
        {
            key: "isVsfRetry",
            value: function isVsfRetry(error) {
                return this.isColourSpaceRetry(error) || error && !this.hasInitialLoad && (this.isHdcpRetry(error) || this.isRobustnessFailoverRetry(error));
            }
        },
        {
            key: "isStopping",
            value: function isStopping(sessionState) {
                return [
                    InternalSessionState.Stopped,
                    InternalSessionState.Stopping
                ].includes(sessionState);
            }
        },
        {
            key: "restart",
            value: function restart(restartType) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(restartType === SessionRestartType.RESTART && _this.canRestart())) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.handleRestart(restartType)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(restartType === SessionRestartType.VPF_RETRY && _this.canRetryWithError())) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.handleRestart(restartType)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDefaultRestartSessionItemOverrides",
            value: function getDefaultRestartSessionItemOverrides() {
                var _this_newPreferredAudioTrack, _this_newPreferredAudioTrack1, _this_newPreferredAudioTrack2, _this_newPreferredAudioTrack3, _this_newPreferredAudioTrack_roles, _this_newPreferredAudioTrack4, _this_newPreferredSubtitlesTrack, _this_newPreferredSubtitlesTrack1, _this_newPreferredSubtitlesTrack2, _this_newPreferredSubtitlesTrack3;
                return _object_spread({}, Boolean(this.newPreferredAudioTrack !== undefined) && {
                    preferredAudioLanguages: [
                        ((_this_newPreferredAudioTrack = this.newPreferredAudioTrack) === null || _this_newPreferredAudioTrack === void 0 ? void 0 : _this_newPreferredAudioTrack.languageTag) || ((_this_newPreferredAudioTrack1 = this.newPreferredAudioTrack) === null || _this_newPreferredAudioTrack1 === void 0 ? void 0 : _this_newPreferredAudioTrack1.language)
                    ],
                    preferredAudioMetadata: [
                        {
                            languageTag: ((_this_newPreferredAudioTrack2 = this.newPreferredAudioTrack) === null || _this_newPreferredAudioTrack2 === void 0 ? void 0 : _this_newPreferredAudioTrack2.languageTag) || ((_this_newPreferredAudioTrack3 = this.newPreferredAudioTrack) === null || _this_newPreferredAudioTrack3 === void 0 ? void 0 : _this_newPreferredAudioTrack3.language),
                            isAudioDescription: !!((_this_newPreferredAudioTrack4 = this.newPreferredAudioTrack) === null || _this_newPreferredAudioTrack4 === void 0 ? void 0 : (_this_newPreferredAudioTrack_roles = _this_newPreferredAudioTrack4.roles) === null || _this_newPreferredAudioTrack_roles === void 0 ? void 0 : _this_newPreferredAudioTrack_roles.includes(AudioRole.Description))
                        }
                    ]
                }, Boolean(this.newPreferredSubtitlesTrack !== undefined) && {
                    preferredSubtitlesLanguages: [
                        ((_this_newPreferredSubtitlesTrack = this.newPreferredSubtitlesTrack) === null || _this_newPreferredSubtitlesTrack === void 0 ? void 0 : _this_newPreferredSubtitlesTrack.languageTag) || ((_this_newPreferredSubtitlesTrack1 = this.newPreferredSubtitlesTrack) === null || _this_newPreferredSubtitlesTrack1 === void 0 ? void 0 : _this_newPreferredSubtitlesTrack1.language)
                    ],
                    preferredSubtitleMetadata: [
                        {
                            languageTag: ((_this_newPreferredSubtitlesTrack2 = this.newPreferredSubtitlesTrack) === null || _this_newPreferredSubtitlesTrack2 === void 0 ? void 0 : _this_newPreferredSubtitlesTrack2.languageTag) || ((_this_newPreferredSubtitlesTrack3 = this.newPreferredSubtitlesTrack) === null || _this_newPreferredSubtitlesTrack3 === void 0 ? void 0 : _this_newPreferredSubtitlesTrack3.language)
                        }
                    ]
                }, Boolean(this.newPreferredBitrateCap !== undefined) && {
                    playerBitrateLimits: {
                        maxBitRate: this.newPreferredBitrateCap
                    }
                }, this.isColourSpaceRetry(this.sessionFatalError) && {
                    videoFormatConfig: {
                        support: {
                            supportedColourSpaces: [
                                VideoColourSpace.SDR
                            ]
                        }
                    }
                }, Boolean(this.sessionFatalError) && {
                    slePrerollEnabled: false
                });
            }
        },
        {
            key: "getSessionItemOverrides",
            value: function getSessionItemOverrides() {
                var _this_currentSession;
                var sessionMaxVideoFormat = (_this_currentSession = this.currentSession) === null || _this_currentSession === void 0 ? void 0 : _this_currentSession.getMaxVideoFormat();
                if (this.sessionFatalError && this.isHdcpRetry(this.sessionFatalError)) {
                    this.newMaxVideoFormat = VideoFormat.HD;
                    this.newPreferredBitrateCap = MAX_720P_BITRATE_CAP;
                } else if (this.sessionFatalError && this.isRobustnessFailoverRetry(this.sessionFatalError) && sessionMaxVideoFormat) {
                    // Downgrade the max video format to the next lowest format
                    var currentMaxVideoFormatIndex = Math.min(ROBUSTNESS_FAILURE_STEPDOWN.indexOf(sessionMaxVideoFormat) + 1, ROBUSTNESS_FAILURE_STEPDOWN.length - 1);
                    this.newMaxVideoFormat = ROBUSTNESS_FAILURE_STEPDOWN[currentMaxVideoFormatIndex];
                    this.robustnessFailoverObservable.notifyObservers({
                        maxVideoFormat: this.newMaxVideoFormat
                    });
                }
                var sessionItemOverrides = this.getDefaultRestartSessionItemOverrides();
                if (this.sessionFatalError && (this.isHdcpRetry(this.sessionFatalError) || this.isQualityFailoverRetry(this.sessionFatalError) || this.isRobustnessFailoverRetry(this.sessionFatalError)) && Boolean(this.newMaxVideoFormat !== undefined)) {
                    var _sessionItemOverrides_videoFormatConfig;
                    if ((_sessionItemOverrides_videoFormatConfig = sessionItemOverrides.videoFormatConfig) === null || _sessionItemOverrides_videoFormatConfig === void 0 ? void 0 : _sessionItemOverrides_videoFormatConfig.support) {
                        sessionItemOverrides.videoFormatConfig.support.maxVideoFormat = this.newMaxVideoFormat;
                    } else {
                        sessionItemOverrides.videoFormatConfig = {
                            support: {
                                maxVideoFormat: this.newMaxVideoFormat
                            }
                        };
                    }
                }
                return sessionItemOverrides;
            }
        },
        {
            key: "setIsRetryEnabledForSessionItem",
            value: function setIsRetryEnabledForSessionItem(sessionItem) {
                if (checkIsSessionItemSleAutoplayType(sessionItem)) {
                    this.isRetryEnabledForSessionItem = false;
                }
            }
        },
        {
            key: "isSessionLowestVideoFormat",
            value: function isSessionLowestVideoFormat() {
                var _this_currentSession;
                return ((_this_currentSession = this.currentSession) === null || _this_currentSession === void 0 ? void 0 : _this_currentSession.getMaxVideoFormat()) === LOWEST_VIDEO_FORMAT;
            }
        },
        {
            key: "canRestart",
            value: function canRestart() {
                return Boolean(this.hasSessionFinishedLoading && !this.hasReceivedSleBingeEvent && this.restartStatus === SessionRestartStatus.IDLE && !this.isStoppingSessionForRestart && this.isRetryEnabledForSessionItem);
            }
        },
        {
            key: "canRetryWithError",
            value: function canRetryWithError() {
                var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.sessionFatalError;
                var _this_internalRetryConfig, _this_internalRetryConfig1, _this_internalRetryConfig2, _this_internalRetryConfig3, _this_internalRetryConfig4, _this_internalRetryConfig5;
                if (!this.isRetryEnabledForSessionItem) {
                    return false;
                }
                var timePassedSinceLastRetry = (Date.now() - this.lastRetryDateTimestamp) / 1000;
                var _this_internalRetryConfig_cooldownPeriodSecs;
                // VPF
                var vpfRetry = Boolean(((_this_internalRetryConfig = this.internalRetryConfig) === null || _this_internalRetryConfig === void 0 ? void 0 : _this_internalRetryConfig.vpfRetryEnabled) && this.hasSessionFinishedLoading && error && !this.hasReceivedSleBingeEvent && timePassedSinceLastRetry >= ((_this_internalRetryConfig_cooldownPeriodSecs = (_this_internalRetryConfig1 = this.internalRetryConfig) === null || _this_internalRetryConfig1 === void 0 ? void 0 : _this_internalRetryConfig1.cooldownPeriodSecs) !== null && _this_internalRetryConfig_cooldownPeriodSecs !== void 0 ? _this_internalRetryConfig_cooldownPeriodSecs : DEFAULT_COOLDOWN_PERIOD_SECS) && (!this.isHdcpRetry(error) || ((_this_internalRetryConfig2 = this.internalRetryConfig) === null || _this_internalRetryConfig2 === void 0 ? void 0 : _this_internalRetryConfig2.hdcpFailoverRetryEnabled)));
                // VSF - ColourSpaceActivation
                var vsfRetry = Boolean(this.isColourSpaceRetry(error));
                var vsfHdcpFailover = Boolean(error && ((_this_internalRetryConfig3 = this.internalRetryConfig) === null || _this_internalRetryConfig3 === void 0 ? void 0 : _this_internalRetryConfig3.hdcpFailoverRetryEnabled) && (!this.hasSessionFinishedLoading || this.lastRetryDateTimestamp) && this.isHdcpRetry(error));
                // VSF - QualityFailover
                var vsfQualityFailover = Boolean(((_this_internalRetryConfig4 = this.internalRetryConfig) === null || _this_internalRetryConfig4 === void 0 ? void 0 : _this_internalRetryConfig4.qualityFailoverEnabled) && this.isQualityFailoverRetry(error));
                // VSF - Robustness Failover
                var vsfRobustnessFailover = Boolean(error && ((_this_internalRetryConfig5 = this.internalRetryConfig) === null || _this_internalRetryConfig5 === void 0 ? void 0 : _this_internalRetryConfig5.robustnessFailoverEnabled) && !this.hasSessionFinishedLoading && !this.isSessionLowestVideoFormat() && this.isRobustnessFailoverRetry(error));
                return vpfRetry || vsfRetry || vsfQualityFailover || vsfHdcpFailover || vsfRobustnessFailover;
            }
        },
        {
            key: "isErrorRecoverable",
            value: function isErrorRecoverable(error) {
                var NON_RECOVERABLE_ERROR_CODES = [
                    'ADDON.OVP-HEARTBEAT.ERROR',
                    'ERROR.PLAYER.ANDROID.DRM',
                    'Security_Terminate'
                ];
                var NON_RECOVERABLE_ERROR_REASONS = new Set([
                    ErrorReason.Embargo
                ]);
                var isNonRecoverableCode = NON_RECOVERABLE_ERROR_CODES.some(function(code) {
                    return error.code.includes(code);
                });
                var isNonRecoverableReason = error.reason !== undefined && NON_RECOVERABLE_ERROR_REASONS.has(error.reason);
                return !isNonRecoverableCode && !isNonRecoverableReason;
            }
        },
        {
            key: "prepareForRestart",
            value: function prepareForRestart(restartType) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(restartType === SessionRestartType.RESTART)) return [
                                    3,
                                    2
                                ];
                                _this.isStoppingSessionForRestart = true;
                                return [
                                    4,
                                    _this.currentSession.stop().catch(function() {}).then(function() {
                                        _this.isStoppingSessionForRestart = false;
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                switch(restartType){
                                    case SessionRestartType.RESTART:
                                        _this.restartStatus = SessionRestartStatus.RESTARTING;
                                        _this.sessionEventProxy.notifySessionRestartStarted();
                                        break;
                                    case SessionRestartType.VPF_RETRY:
                                        _this.restartStatus = SessionRestartStatus.VPF_RETRYING;
                                        _this.sessionEventProxy.notifySessionRetryStarted(_this.sessionFatalError);
                                        break;
                                }
                                _this.hasSessionFinishedLoading = false;
                                _this.playbackTimeline = null;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPlayoutDataOverrides",
            value: function getPlayoutDataOverrides() {
                var playoutDataOverrides = _object_spread({}, this.audioState);
                playoutDataOverrides.preferredAudioTrack = this.newPreferredAudioTrack;
                playoutDataOverrides.preferredSubtitlesTrack = this.newPreferredSubtitlesTrack;
                if (this.playbackTimeline) {
                    var _this_playbackTimeline = this.playbackTimeline, position = _this_playbackTimeline.position, liveWindow = _this_playbackTimeline.liveWindow;
                    if (this.isVodManifest) {
                        playoutDataOverrides.position = position;
                    } else if (this.isLinearManifest && this.shouldBookmarkLinearContent()) {
                        playoutDataOverrides.linearPosition = {
                            liveWindow: liveWindow,
                            position: position
                        };
                    }
                }
                return playoutDataOverrides;
            }
        },
        {
            key: "getPlayoutRequestOverrides",
            value: function getPlayoutRequestOverrides() {
                return this.sessionFatalError && this.isHdcpRetry(this.sessionFatalError) ? {
                    hdcpEnabled: false
                } : undefined;
            }
        },
        {
            key: "createRestartOptions",
            value: function createRestartOptions(retryType) {
                var restartOptions = {
                    restartType: retryType,
                    penalizedCdnName: retryType === SessionRestartType.VPF_RETRY ? this.currentCdnName : undefined
                };
                restartOptions.playoutDataOverrides = this.getPlayoutDataOverrides();
                restartOptions.sessionItemOverrides = this.getSessionItemOverrides();
                restartOptions.playoutRequestOverrides = this.getPlayoutRequestOverrides();
                return restartOptions;
            }
        },
        {
            key: "shouldBookmarkLinearContent",
            value: /**
     * Should only do a Linear/SLE bookmark when playing an asset and device/player combination that allows it.
     * If it's allowed, we should only do it when not at LiveEdge.
     */ function shouldBookmarkLinearContent() {
                var _this_playbackTimeline, _this_currentSession;
                return Boolean(this.isUsingExtendedDvrWindow && !((_this_playbackTimeline = this.playbackTimeline) === null || _this_playbackTimeline === void 0 ? void 0 : _this_playbackTimeline.isAtLiveEdge) && CoreVideoInternal.capabilities.hasExtendedDvrSupport() && ((_this_currentSession = this.currentSession) === null || _this_currentSession === void 0 ? void 0 : _this_currentSession.isLinearScrubbingSupported()));
            }
        }
    ]);
    return SessionRestartController;
}();

//# sourceMappingURL=session-restart-controller.js.map